<template>
  <b-form-group
    label="Hatırlatma Tarihi"
    label-for="remind"
  >
    <validation-provider
      #default="{ errors }"
      name="Başlık"
      rules="required"
    >
      <b-form-datepicker
        id="remind"
        v-model="dataItem.reminder.remind"
        v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Remind',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['interviews/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
